import { render, staticRenderFns } from "./TitleHeaderAction.vue?vue&type=template&id=ecdcd1c8&scoped=true&"
import script from "./TitleHeaderAction.vue?vue&type=script&lang=js&"
export * from "./TitleHeaderAction.vue?vue&type=script&lang=js&"
import style0 from "./TitleHeaderAction.vue?vue&type=style&index=0&id=ecdcd1c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdcd1c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
